import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ShipIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 3.16832L6 3.36832C6 2.70905 6.1389 2.05718 6.40765 1.45518L6.4265 1.41295C6.45488 1.34937 6.54512 1.34937 6.5735 1.41295L6.67388 1.6378C6.88888 2.11941 7 2.6409 7 3.16832ZM5 7.36832C5 6.16832 3.66667 4.86832 3 4.36832L10 3.36832L10.0259 3.37692C10.537 3.54673 11.6068 3.90214 12 5.86832C12.3 7.36832 11.5 9.20165 11 9.36832L3 10.8683C3.66667 10.3683 5 8.86832 5 7.36832ZM1.4178 12.2987C1.17671 12.3389 1 12.5475 1 12.7919V13.3683C1 14.4729 1.89543 15.3683 3 15.3683H9C12.3137 15.3683 15 12.6821 15 9.36832V8.36832L14.5 7.36832C14.7761 7.36832 15 7.14446 15 6.86832C15 6.59217 14.7761 6.36832 14.5 6.36832H14.4384C14.1808 6.36832 13.9562 6.54369 13.8937 6.79367L13.6361 7.82403C13.2498 9.36899 11.9839 10.5377 10.4131 10.7995L1.4178 12.2987Z"
		/>
	</svg>
))
